import { action, observable } from 'mobx'
import { toast } from 'react-toastify';
import BookingService from '../../../../services/BookingService';
import EntradaAntecipadaService from '../../../../services/EntradaAntecipadaService';
import lscache from 'lscache';
import MeuTeconService from '../../../../services/MeuTeconService';
import { formatarDataCustomHTML } from '../../../../utils/formatar';

export default class EntradaAntecipadaStore{
    @observable numeroBooking;
    @observable navioSelecionado;
    @observable opcoesResponsavelCusto;
    @observable container;
    @observable listaContainer;
    @observable responsavelCusto;
    @observable responsavelCustoSelecionado;
    /* ESTADOS */
    @observable entradaAntecipadaLiberada;
    @observable modalNovaSolicitacao;
    @observable termoDeAceite;
    @observable listaMensagens;
    @observable modalTermo;
    @observable confirmaModal;
    @observable carregandoTabela;
    @observable carregandoListaResponsavel;
    @observable carregandoNavioFiltro;
    @observable todosMarcados;
    @observable selecionados;
    @observable itens;
    @observable modalInativar;
    @observable Erros;
    toShow;
    turn;

    /* FILTRO */
    @observable numeroBookingFiltro;
    @observable vesselVisitFiltro;
    @observable navioSelecionadoFiltro;
    @observable filtroContainer;

    /* TABELA */
    @observable dadosTabela;

    constructor(){
        this.responsavelCusto = "";
        this.navioSelecionado = "";
        this.container = "";
        this.listaMensagens = false;
        this.listaContainer = [];
        this.numeroBooking = "";
        this.Erros = false;
        this.opcoesResponsavelCusto = [];
        this.selecionados = [];
        this.itens = [];
        this.responsavelCustoSelecionado = "";

        /* SERVICOS */
        this.entradaAntecipadaService = new EntradaAntecipadaService();
        this.bookingService = new BookingService();
        this.meuTeconService = new MeuTeconService();
        /* ESTADOS */
        this.entradaAntecipadaLiberada = false;
        this.modalNovaSolicitacao = false;
        this.termoDeAceite = false;
        this.modalTermo = false;
        this.confirmaModal = false;
        this.carregandoTabela = false;
        this.carregandoListaResponsavel = false;
        this.carregandoNavioFiltro = false;
        this.toastId = null; 
        this.modalInativar = false;


        /* FILTRO */
        this.numeroBookingFiltro = "";
        this.vesselVisitFiltro = "";
        this.navioSelecionadoFiltro = "";
        this.filtroContainer = "";

        /* TABELA */
        this.colunasTabela = [
            {
                dataField: 'DataEntrada',
                text: "Data de Liberação",
                align: "center",
                sort: true,
                formatter: formatarDataCustomHTML
            },
            {
                dataField: 'Container',
                text: "Container",
                align: "center",
                sort: true
            },
            {
                dataField: 'VesselVisit',
                text: "Navio",
                align:"center",
                sort: true
            },            {
                dataField: 'Booking',
                text: "Booking",
                align:"center",
                sort: true
            },
            {
                dataField: 'Situacao',
                text: "Situação",
                align:"center",
                sort: true
            }
        ]
        this.dadosTabela = []

    }
     
    @action
    setNumeroBooking = (valor) => {
            this.numeroBooking = valor
    }
    @action
    setNavio(valor){
        this.navioSelecionado = valor
    };

    @action
    setContainer(valor){
        this.container = valor
    };

    @action
    addContainer = () => {
        const regex = /^[a-zA-Z]{4}[0-9]{7}$/
        if(this.container.length)
        {
            if(regex.test(this.container)){
                if(!this.listaContainer.find(item => item == this.container)){
                    this.listaContainer.push(this.container)
                }
                
             }else {
                this.a = toast("Impossível adicionar novo container, código do container inválido! Exemplo: MABC1234567", {type: "error", autoClose: 5000})
             }
             this.container = ""
        }
    }

    @action
    removeContainer = (valor) => {
        this.listaContainer = this.listaContainer.filter(container => container != valor)
    }

    @action
    abrirModalInativar = () => {
        this.modalInativar = true;
    };

    @action
    cancelaInativar = () => {
        this.modalInativar = false;
    };

    @action
    setResponsavelCusto(valor){
        this.responsavelCusto = valor
    }

    @action
    chamaModal = () => {
     this.confirmaModal = true;   
    }

    @action
    setResponsavelCustoSelecionado = (valor)=>{
        console.log("o responsavel é: ", valor)
        this.responsavelCustoSelecionado = valor
    }

    @action
    setNumeroBookingFiltro(valor){
        this.numeroBookingFiltro = valor
    }
    @action
    setContainerFiltro(valor){
            this.filtroContainer = valor
    }
    @action
    setNavioFiltro(valor){
        this.navioSelecionadoFiltro = valor
    };

    @action
    setEstadoModal = (valor) => {
        this.modalTermo = valor;
    }

    @action
    setEstadoModalSolicitacao = (valor) => {
        this.modalNovaSolicitacao = valor
    }


    @action
    setEStadoConfirmaModal = (valor) => {
        this.confirmaModal = valor;
    }


    @action
    aceitarTermo = async () => {
        if (this.modalTermo) {
            try{
                const {data} = await this.entradaAntecipadaService.PostTermo();
                this.modalTermo = false; 
               this.setEstadoModalSolicitacao(true);         
            }catch(erro){
                this.a = toast("Houve um erro ao tentar aceitar o termo, tente novamente ou contate o suporte.", {type: "error", autoClose: 5000})
            }
        }

     }

    exibirToastSalvando = () => {
        this.a = toast("Salvando...", {type: "default", autoClose: 5000})
    }

    exibirToastErro = (mensagem) => {
        toast.update(this.toastId, {type: "error", render: mensagem, autoClose: 5000})
    }
    exibirToastSucesso = (mensagem) => {
        toast.update(this.toastId, {type: "success", render: mensagem, autoClose: 5000})
    }

    @action
    resetarFormularioSolicitacao = () => {
        this.container = "";
        this.numeroBooking = "";
        this.navioSelecionado = "";
        this.listaContainer = [];
        this.responsavelCustoSelecionado = "";
    }

    carregarNavio = async () => {
        console.log(this.numeroBooking)
        if(this.numeroBooking.length){
            const {data} = await this.bookingService.carregar(this.numeroBooking)
            console.log(data);
            if(data.Id){
                this.setNavio(data.VesselName + ' - ' + data.VesselVisit)
                
            }
        }
    }


    fecharModal = () => {
        this.listaMensagens = false;
    }
    

    carregarSituacaoEntradaAntecipada = async () => {
        const {data} = await this.entradaAntecipadaService.SituacaoEntradaAntecipada()
        if(data.Sucesso) this.entradaAntecipadaLiberada = true
        else toast(data.Mensagem, {type: "error"})
    }

    carregarNavioFiltro = async ()=>{
        try{
            if(this.numeroBookingFiltro.length){
                this.carregandoNavioFiltro = true
                const {data} = await this.bookingService.carregar(this.numeroBookingFiltro)
                if(data.Id){
                    this.setNavioFiltro(data.VesselName + ' - ' + data.VesselVisit)
                    this.vesselVisitFiltro = data.VesselVisit
                }
                else{
                    this.setNavioFiltro("")
                    this.vesselVisitFiltro = ""
                }
            }
            else{
                this.setNavioFiltro("")
                this.vesselVisitFiltro = ""
            } 

        }catch(erro){

        }finally{
            this.carregandoNavioFiltro = false
        }
    }

    carregarListaResponsavelCusto = async ()=>{
        this.carregandoListaResponsavel = true
        try{
            const {data} = await this.meuTeconService.ListarEmpresasPorUsuario()
            this.opcoesResponsavelCusto = data.map((element) => {
                return {label: element.RazaoCnpj, value: element.Cgc}
            })
        }catch(erro){

        }finally{
            this.carregandoListaResponsavel = false
        }
    }

    @action
    async buscarSolicitacoes(){
        this.carregandoTabela = true
        try{
            let a = {};
            const {data} = await this.entradaAntecipadaService.BuscarSolicitacoes(this.numeroBookingFiltro, this.vesselVisitFiltro, this.filtroContainer)
            if (data.ExceptionMessage === "Necessário adicionar algum filtro para poder prosseguir!") {
                this.a = toast(data.ExceptionMessage, { type: "error", autoClose: 5000 })
                return
            } 
            this.dadosTabela = data
            console.log(data)
        }catch(erro){
            console.log(erro)
        }finally{
            this.carregandoTabela = false
        }
    }

    @action
    marcar = (dados) => {
        dados.marcado = !dados.marcado;
        this.selecionados = this.dadosTabela.filter(i => i.marcado===true);
    };

    @action
    confirmarInativar = () => {
        this.a = toast("Inativando...", {type: "default", autoClose: 5000})
        this.entradaAntecipadaService.PostInativar(this.selecionados).then(response => {        
            this.modalInativar = false;
            if (response.data) {
                if(response.data.Sucesso){
                    this.a = toast("Solicitações inativadas com sucesso.", { type: "success",  autoClose: 5000 })
                    this.buscarSolicitacoes();
                }else {
                    toast.update(this.a, {type: "error", render: response.data.Mensagem, autoClose: 5000})
                    this.buscarSolicitacoes();    
                }
            } else {        
                this.a = toast("Problemas ao tentar inativar", {type: "error", autoClose: 5000})
            }
        })
    };




    // @action
    // async verificaTermo(){
      
    //         const {data} = await this.entradaAntecipadaService.VerificarTermo();
           
    //         if(data.length == 0){
    //             this.modalTermo = true;
    //             this.termoDeAceite = false;
    //         }else{  
    //             if(lscache.get("MembershipuserId") == data[0].UsuarioID){
    //                 this.modalTermo = false;
    //                 this.termoDeAceite = true;
                 
    //                }   
    //         } 
    // }

    @action
    ModalSolicitacao = () => {
        this.chamaModal()
}

    @action
    marcarTodas = (checked) => {
        this.dadosTabela.map(item => 
                item.marcado = checked
            )
        this.selecionados = this.dadosTabela.filter(i => i.marcado === true)
    };



    @action
    salvarSolicitacao = async () => {
           this.confirmaModal = false;
        try{
                this.exibirToastSalvando()
                const pacote = {
                    NumeroBooking: this.numeroBooking,
                    ListaContainer: this.listaContainer,
                    ResponsavelCusto: this.responsavelCustoSelecionado.value
                }
                console.log('Pacote enviado: ', pacote)
                const {data} = await this.entradaAntecipadaService.NovaSolicitacao(pacote)
                console.log('resposta', data)

                if(data.Sucesso) {
                    var d = data.Mensagem;
                    this.a = toast("Solicitação criada com sucesso.", { type: "success", render: d, autoClose: 5000 })
                    this.setEstadoModalSolicitacao(false)
                }
                else {
                    var d = data.Mensagem;
                    // this.a = toast(this.d, { type: "error", render: d , autoClose: 5000})
                    // this.listaMensagens = data.errosMensagem;
                    this.listaMensagens = data.Mensagem.split(".");
                    console.log('listaMensagens', this.listaMensagens)
                    this.setEstadoModalSolicitacao(true)
                    //this.ter

                    this.Erros = true;
                }

            }catch(erro){
                console.log(erro)
                this.exibirToastErro(erro.toString())
            }finally{
                this.confirmaModal = false;
            }
        
}
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/entrada-antecipada/stores/EntradaAntecipadaStore.js